import { get, post, put, destroy } from './config';

const Expeditor = {
    getPublishedOrders: (page, limit, orderNo, cityIdFrom, cityIdTo, shippingDate, unloadingDate) =>
        get(`v1/orders/expeditor/search?status=published&page=${page}&limit=${limit}&orderNo=${orderNo}&cityIdFrom=${cityIdFrom}&cityIdTo=${cityIdTo}&shippingDate=${shippingDate}&unloadingDate=${unloadingDate}`),
    sendAuctionBid: (data) => 
        post('v1/auctionbid/expeditor', data),
    getOrderListForExpeditor: (params) =>
        post(`v1/orders/expeditor/list`, params),
    getStatusWithOrderCountsForExpeditor: (data) =>
        post(`/v1/orders/expeditor/quantity`, data),
}

export default Expeditor;